/* global Swiper */
$(() => {
  $('.js-article-slider').each(function sliderInit() {
    const $this = $(this);
    const swiper = new Swiper($this, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: 'fade',
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });
});



// WEBPACK FOOTER //
// ./src/scripts/components/sliders/article-slider.js